import React from 'react'
import './style/Experiance.css'
import Tree from './Cards/Tree'

function Experiance() {
    return (
        <div className="experiance">
            <span>Experiance</span>
            <h2>Work Experiance</h2>
            <Tree />
        </div>
    )
}

export default Experiance
